import React from 'react'

import { css, useTheme } from '@emotion/react'
import styled from '@emotion/styled'

import CheckIcon from '../icons/CheckIcon'
import Icon from './Icon'

const List = styled.ul<{ rowGap: string }>`
  display: grid;
  row-gap: ${props => props.rowGap};
  text-align: start;

  li {
    display: flex;
    color: ${props => props.theme.colors.secondaryLabel};
    line-height: 1.5rem;
  }
`

const IconContainer = styled.div<{ variant: string }>`
  font-size: 1.5rem;
  margin-right: 1rem;

  ${props => {
    switch (props.variant) {
      case 'primary':
        return css`
          color: ${props.theme.colors.primary};
        `
      case 'neutral':
        return css`
          color: ${props.theme.colors.label};
        `
      default:
        return
    }
  }}
`

export type ChecklistProps = {
  items: React.ReactNode[]
  rowGap?: string
  variant?: 'primary' | 'neutral' | 'outlined'
}

const Checklist: React.FC<ChecklistProps> = ({ items, rowGap = '0.75rem', variant = 'primary' }) => {
  const theme = useTheme()

  return (
    <List rowGap={rowGap}>
      {items.map((item, index) => (
        <li key={index}>
          <IconContainer variant={variant} aria-hidden={true}>
            {variant === 'outlined' ? <Icon color={theme.colors.primary} name="checkmark-circle" /> : <CheckIcon />}
          </IconContainer>
          <span>{item}</span>
        </li>
      ))}
    </List>
  )
}

export default Checklist
